<template>
  <component
    :is="tag"
    class="nav-item"
    v-bind="componentAttrs"
    @click="handleClick"
  >
    <a v-if="tag !== 'router-link'" :class="'nav-link ' + type">
      <b-icon v-if="icon && showIcon" :icon="icon" class="sidebar-menu-icon" />
      <transition name="sidebar-menu-label-fade">
        <span v-if="!collapsed" class="sidebar-menu-label">{{ name }}</span>
      </transition>
    </a>
    <template v-else>
      <b-icon v-if="icon && showIcon" :icon="icon" class="sidebar-menu-icon" />
      <transition name="sidebar-menu-label-fade">
        <span v-if="!collapsed" class="sidebar-menu-label">{{ name }}</span>
      </transition>
    </template>
  </component>
</template>

<script>
export default {
  name: "SidebarLink",
  inheritAttrs: false,
  inject: {
    autoClose: { default: true },
    addLink: { default: () => {} },
    removeLink: { default: () => {} }
  },
  props: {
    name: String,
    icon: String,
    showIcon: { type: Boolean, default: true },
    type: { type: String, default: "link" },
    activeLinkIndex: Number,
    tag: { type: String, default: "router-link" },
    to: { type: [String, Object], default: null },
    collapsed: { type: Boolean, default: false }
  },
  computed: {
    componentAttrs() {
      // Passa todos os attrs + listeners
      if (this.tag === "router-link" && this.to) {
        return { ...this.$attrs, to: this.to, ...this.$listeners };
      }
      return { ...this.$attrs, ...this.$listeners };
    }
  },
  methods: {
    isActive() {
      return this.$el.classList.contains("active");
    },
    handleClick(event) {
      if (this.collapsed) {
        this.$emit("toggle-collapse");
      }
    }
  },
  mounted() {
    if (this.addLink) this.addLink(this);
  },
  beforeUnmount() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) this.removeLink(this);
  }
};
</script>

<style scoped>
.sidebar-menu-icon {
  font-size: 1.4rem;
  margin-right: 0.7em;
  vertical-align: middle;
  transition: color 0.25s;
}
.sidebar-menu-label {
  vertical-align: middle;
  font-size: 15px;
  font-weight: 500;
}
.sidebar-menu-label-fade-enter-active,
.sidebar-menu-label-fade-leave-active {
  transition: opacity 0.22s, max-width 0.22s, margin 0.22s;
}
.sidebar-menu-label-fade-enter-from,
.sidebar-menu-label-fade-leave-to {
  opacity: 0;
  max-width: 0;
  margin-left: 0;
}
.sidebar-menu-label-fade-enter-to,
.sidebar-menu-label-fade-leave-from {
  opacity: 1;
  max-width: 150px;
  margin-left: 0.7em;
}
</style>
